/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProgramBudgetUsage { 
    /**
     * The monthly cap in US dollars. Absent when nothing caps this program — a dedicated program whose limit was left empty — and then `percent` and `state` are absent too.
     */
    limitUsd?: number;
    /**
     * Billable spend so far this month, straight from the ledger\'s stored total.
     */
    spentUsd: number;
    /**
     * spentUsd as a percentage of limitUsd, rounded to two decimals. May exceed 100.
     */
    percent?: number;
    /**
     * Bar colour: ok below 80%, warning from 80%, critical from 95%, exceeded at 100%. Read off the exact ratio, not off the rounded `percent`, so that it always agrees with whether a send is actually refused; `exceeded` means blocked only while `enforced` is true.
     */
    state?: ProgramBudgetUsage.StateEnum;
    /**
     * First instant of the current UTC calendar month.
     */
    periodStart: string;
    /**
     * When the counter starts over: the first instant of the next UTC month.
     */
    resetsAt: string;
    /**
     * Whether reaching the limit actually blocks sends. False while the platform kill switch (BUDGET_ENFORCEMENT) is off — the bar still fills and still warns.
     */
    enforced: boolean;
}
export namespace ProgramBudgetUsage {
    export type StateEnum = 'ok' | 'warning' | 'critical' | 'exceeded';
    export const StateEnum = {
        Ok: 'ok' as StateEnum,
        Warning: 'warning' as StateEnum,
        Critical: 'critical' as StateEnum,
        Exceeded: 'exceeded' as StateEnum
    };
}


